import React from "react";
import Navbar from "../../Components/Navbar/Navbar";
import UnderstandingOur from "../../Components/TermsSection/UnderstandingOur/UnderstandingOur";
import TermsOverview from "../../Components/TermsSection/TermsOverview/TermsOverview";
import Footer from "../../Components/Footer/Footer";
const TermsPage = ({ header, isVisible, footerData }) => {
  return (
    <>
      <div>
        <Navbar header={header} isVisible={isVisible} />
      </div>
      <div>
        <UnderstandingOur />
        <TermsOverview />
      </div>
     
        <Footer footerData={footerData} />
     
    </>
  );
};

export default TermsPage;
